import { Button, Popconfirm, Space, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { deleteNotification, getNotifications } from "../../store/slices/notificationSlice";
import { DeleteFilled, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Can from "../../permission/Can";

const NotificationList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showPopconfirm = (id) => {
        setOpen(id);
    };

    const handleDeleteNotification = async (id) => {
        // try {
        //     setConfirmLoading(true);

        //     const resultAction = await dispatch(deleteNotification(id));

        //     if (deleteNotification.fulfilled.match(resultAction)) {
        //         setAlertMessage(resultAction?.payload?.message || "Deleted successfully");
        //         setAlertType("success");
        //         setReload(!reload);
        //         setOpen(null);
        //     } else {
        //         setAlertMessage(resultAction?.payload?.error || "Delete failed");
        //         setAlertType("error");
        //     }
        // } catch (error) {
        //     setAlertMessage("Error deleting notification");
        //     setAlertType("error");
        // } finally {
        //     setConfirmLoading(false);
        //     setTimeout(() => setAlertMessage(""), 4000);
        // }
    };

    const handleCancel = () => {
        setOpen(null);
    };

    const columns = [
        {
            title: "Message",
            dataIndex: "message",
            key: "message",
            render: (text) => text?.length > 50 ? text.slice(0, 50) + "..." : text
        },
        {
            title: "Audience",
            dataIndex: "target_audience",
            key: "target_audience",
            render: (audience) => (
                <Tag color="blue">{audience?.toUpperCase()}</Tag>
            )
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <Tag color={status === "sent" ? "green" : "orange"}>
                    {status?.toUpperCase()}
                </Tag>
            )
        },
        {
            title: "Scheduled At",
            dataIndex: "scheduled_at",
            key: "scheduled_at",
            render: (_, data) =>
                data?.scheduled_at
                    ? new Date(data.scheduled_at).toLocaleString()
                    : "-"
        },
        {
            title: "Sent At",
            dataIndex: "sent_at",
            key: "sent_at",
            render: (_, data) =>
                data?.sent_at
                    ? new Date(data.sent_at).toLocaleString()
                    : "-"
        },
        // {
        //     title: "Actions",
        //     key: "actions",
        //     render: (_, data) => (
        //         <Space>
        //             {/* View */}
        //             <Button
        //                 icon={<EyeOutlined />}
        //                 size="small"
        //                 onClick={() => navigate('/notification/view/' + data?._id)}
        //             >
        //                 View
        //             </Button>

        //             {/* Delete */}
        //             {/* <Popconfirm
        //                 title="Delete confirmation"
        //                 description="Do you want to delete this notification?"
        //                 open={open === data?._id}
        //                 icon={<DeleteFilled />}
        //                 onConfirm={() => handleDeleteNotification(data?._id)}
        //                 okButtonProps={{ loading: confirmLoading }}
        //                 onCancel={handleCancel}
        //             >
        //                 <Button
        //                     icon={<DeleteOutlined />}
        //                     onClick={() => showPopconfirm(data?._id)}
        //                     size="small"
        //                     danger
        //                 >
        //                     Delete
        //                 </Button>
        //             </Popconfirm> */}
        //         </Space>
        //     ),
        // },
    ];

    return (
        <div>
            <div
                style={{
                    marginBottom: 16,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <h1>Notifications</h1>

                <Can permission="create_notification">
                    <Button
                        type="primary"
                        onClick={() => navigate("/notification/add")}
                    >
                        Add Notification
                    </Button>
                </Can>
            </div>

            <TableComponent
                listData={getNotifications}
                columns={columns}
                reload={reload}
                placeholder="Search notifications..."
            />
        </div>
    );
};

export default NotificationList;